module.exports = __webpack_public_path__ + "static/media/icon.cf317c23.png";